export default "__VITE_ASSET__tV5IZuq3__"